<template>
    <div>

        <vue-headful title="MIC :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-shield"></i> Management Involvement & Commitment</li>
                <li class="ml-2">
                    <router-link :to="`/hse/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create MIC</router-link>
                </li>
                <li class="ml-2">
                    <router-link :to="`/hse/import`" class="btn btn-sm btn-primary"><i class="fa fa-file-excel-o"></i> Import</router-link>
                </li>
            </ol>
        </h4>

        <saved-filter-title :filterKey="'hseFilters'" />

        <div class="card">
            <div class="card-body">
                <hse-list :allowFilterSaving="true" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {

            }
        },

        methods: {

        },
    }
</script>
